import React , { useState, useEffect, useRef, Fragment } from "react";
import "./message-banner.scss";

export interface IBanner {
  children: any; // eslint-disable-line
  heightProp?: number;
  getBannerStatus?: () => void;
  getBannerHeight?: (val: number) => void;
}

const MessageBanner = ({children, heightProp, getBannerStatus, getBannerHeight }:IBanner) => {  
  const [notificationToggle, setNotificationToggle] = useState(false);
  const [height, setHeight] = useState<number>(0);

  const container = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    getBannerHeight && getBannerHeight(height);
  }, [height]);

  useEffect(() => {
    heightProp && setHeight(heightProp);
  }, [heightProp]);

  useEffect(() => {
    if (children && container) {
      container.current?.offsetHeight && setHeight(container.current.offsetHeight + (heightProp? heightProp : 0));
    }
  }, [children]);

  window.addEventListener("resize", () => {
    const newSize = container.current?.offsetHeight;
    if (height !== newSize) {
      container.current && setHeight(container.current?.offsetHeight + (heightProp? heightProp : 0));
    }
  });

  const renderNotificationBanner = () => {
    return (
      <div 
        onClick={() => {setNotificationToggle(!notificationToggle); getBannerStatus && getBannerStatus();}} 
        style={{ top: notificationToggle? (height && -height) : heightProp? heightProp : 0}} 
        className="messageBanner" 
        ref={container}>
        {children}
      </div>
    );
  };

  return (
    <Fragment>
      {children && renderNotificationBanner()}
    </Fragment>
  );
};

export default MessageBanner;
